import { FormattedMessage } from 'react-intl';
import { PoolSelect, SelectOption, useFilter } from '@synergy/components';

const auctionSelectOptions: SelectOption[] = [
    { value: true, displayValue: <FormattedMessage id="app.filter.onlyAuctions" /> },
    { value: false, displayValue: <FormattedMessage id="app.filter.noAuctions" /> },
];

export const AuctionFilter = () => {
    const { filter, updateFilter, registerFilterMap } = useFilter();

    const onSelected = (value?: string) => {
        filter.delete('isAuction');
        if (value !== undefined && value !== null) {
            filter.set('isAuction', value);
        }
        updateFilter(filter);
    };

    registerFilterMap('isAuction', typeValue => {
        const type = auctionSelectOptions.find(option => option.value.toString() === typeValue);
        return type?.displayValue;
    });

    return (
        <PoolSelect
            displayEmpty={true}
            name="isAuction"
            label={<FormattedMessage id="app.filter.auctions" />}
            fullWidth={true}
            value={filter.get('isAuction')}
            onValueChange={onSelected}
            options={auctionSelectOptions}
            noSorting={true}
        />
    );
};
